import usePermissions from 'hooks/usePermissions'
import * as React from 'react'

import cn from '@/utils/tailwind/cn'

import Spinner from '../../components/Spinner'
import { isFilledArray } from '../../utils/helpers'

function FormButton({ title, onClick, loading, index, listLength, disabled }) {
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    setIsLoading(loading)
  }, [loading])

  const handleClick = React.useCallback(async () => {
    setIsLoading(true)
    await onClick()
    setIsLoading(false)
  }, [onClick])

  return (
    <button
      className={cn(
        'flex flex-1 space-x-2 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-dark-10',
        {
          'border-b sm:border-b-0 sm:border-r lg:border-b lg:border-r-0':
            index < listLength - 1,
        },
        { 'cursor-not-allowed opacity-50': disabled }
      )}
      disabled={isLoading || disabled}
      onClick={handleClick}
    >
      {isLoading && <Spinner color="onLight" size={20} />}
      <span className="w-full text-left">{title}</span>
    </button>
  )
}

function FormButtonListVertical({
  list,
}: {
  list: { title: string, onClick: Function, loading?: boolean }[],
}) {
  const {
    canSendResponse,
    canArchiveResponse,
    canDeleteResponse,
    canExportPdf,
  } = usePermissions()

  const shouldRender = React.useCallback(
    (title: string) => {
      switch (title) {
        case 'Send Reminder':
        case 'Manually Submit':
        case 'Complete office use':
        case 'Complete Office Use':
          return canSendResponse
        case 'Archive':
          return canArchiveResponse
        case 'Delete':
          return canDeleteResponse
        case 'Download':
        case 'Download packet':
        case 'Download Packet':
          return canExportPdf
        default:
          return true
      }
    },
    [canArchiveResponse, canDeleteResponse, canExportPdf, canSendResponse]
  )

  return (
    isFilledArray(list) && (
      <div className="flex flex-col rounded border sm:mx-6 sm:flex-row lg:mx-0 lg:flex-col">
        {list.map(({ title, onClick, loading, disabled }, index) =>
          shouldRender(title) ? (
            <FormButton
              disabled={disabled}
              index={index}
              key={title}
              listLength={list.length}
              loading={loading}
              onClick={onClick}
              title={title}
            />
          ) : null
        )}
      </div>
    )
  )
}

export default FormButtonListVertical
